<ph-chat-task *ngIf="loading; else loadedCard"
              status="running"
              [title]="loadingLabel || 'Building the document…'"
              [step]="loadingHint || ''"></ph-chat-task>

<ng-template #loadedCard>
    <ph-card flat>
        <ph-toolbar justify="between" nowrap>
            <ph-toolbar nowrap>
                <ph-file-icon [name]="primaryFile?.fileName || ''" [format]="primaryFile?.format || ''"></ph-file-icon>
                <ph-stack gap="tight">
                    <ph-label>{{ title }}</ph-label>
                    <ph-hint *ngIf="primaryFile">{{ primaryFile.fileName }}, {{ primaryFile.sizeLabel }}</ph-hint>
                </ph-stack>
            </ph-toolbar>
            <ph-split-button
                *ngIf="files.length > 1; else singleDownload"
                label="Download"
                icon="download-simple"
                [items]="downloadItems"
                (ph-action)="onDownloadSelect(primaryFile?.format || '')"
                (ph-select)="onDownloadSelect($event.detail)">
            </ph-split-button>
            <ng-template #singleDownload>
                <ph-button *ngIf="primaryFile"
                           variant="secondary" mode="filled" size="small"
                           icon="download-simple"
                           class="deliverable-download-button"
                           (click)="openDownload(primaryFile.downloadUrl)">
                    Download {{ formatLabel(primaryFile.format) }}
                </ph-button>
            </ng-template>
        </ph-toolbar>
    </ph-card>
</ng-template>
